import { SetStateAction } from 'react';
import { createShallowStore, createStoreWithPersist } from '@frontend/store';
import { FilterState } from '../components/filters-drawer';
import { QuickFiltersState } from '../components/quick-filters';

const DEFAULT_QUICK_FILTERS: QuickFiltersState = {
  view: null,
  recurrence: null,
};

const DEFAULT_FILTERS: FilterState = {
  providers: [],
  operatories: [],
  serviceTypes: [],
  startDate: '',
  endDate: '',
  view: undefined,
  recurrenceTypes: [],
};

type RuleExceptionsFiltersStore = {
  filtersMap: Record<string, FilterState>;
  quickFiltersMap: Record<string, QuickFiltersState>;
  setFilters: (locationId: string, update: SetStateAction<FilterState>) => void;
  setQuickFilters: (locationId: string, filters: QuickFiltersState) => void;
  resetFilters: (locationId: string) => void;
};

const useRuleExceptionsFiltersStore = createStoreWithPersist<RuleExceptionsFiltersStore>(
  (set) => ({
    filtersMap: {},
    quickFiltersMap: {},
    setFilters: (locationId, update) => {
      if (!locationId) return;

      set(
        (state) => {
          const previousFilters = state.filtersMap[locationId] ?? DEFAULT_FILTERS;
          const nextFilters = typeof update === 'function' ? update(previousFilters) : update;

          return {
            filtersMap: {
              ...state.filtersMap,
              [locationId]: nextFilters,
            },
          };
        },
        false,
        'SET_RULE_EXCEPTIONS_DETAILED_FILTERS'
      );
    },
    setQuickFilters: (locationId, filters) => {
      if (!locationId) return;

      set(
        (state) => ({
          quickFiltersMap: {
            ...state.quickFiltersMap,
            [locationId]: filters,
          },
        }),
        false,
        'SET_RULE_EXCEPTIONS_QUICK_FILTERS'
      );
    },

    resetFilters: (locationId) => {
      if (!locationId) return;

      set(
        (state) => ({
          quickFiltersMap: {
            ...state.quickFiltersMap,
            [locationId]: DEFAULT_QUICK_FILTERS,
          },
          filtersMap: {
            ...state.filtersMap,
            [locationId]: DEFAULT_FILTERS,
          },
        }),
        false,
        'RESET_RULE_EXCEPTIONS_FILTERS'
      );
    },
  }),
  {
    name: 'schedule-rule-exceptions-filters-store',
  },
  {
    name: 'RuleExceptionsFiltersStore',
    trace: true,
  }
);

export const useRuleExceptionsFiltersShallowStore = createShallowStore(useRuleExceptionsFiltersStore);

export { DEFAULT_FILTERS, DEFAULT_QUICK_FILTERS };
